import { NavLink } from "react-router-dom";
import { ReactComponent as RedDotAlert } from "../../../../src/assets/icons/red_dot_alert.svg";
import CommonTooltip from "../../common/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/activeTabSlice";
import { Fragment, useEffect } from "react";

export const SidebarLinkGroup = ({ links, collapsed }) => {
  const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.activeTab.activeTab);
    useEffect(()=>{
      if(!activeTab){
        dispatch(setActiveTab("Dashboard"));
      }
    },[activeTab])

  const handleSave = (name) => {
    dispatch(setActiveTab(name));
  };
  return (
    <>
      {links.map(({ name, Icon, link, alert, newTab }) => {
        return (
          <Fragment key={name}>
            {/* 🔥 Add HR before these to visually group sections */}
            {(name === "Help & Support" ||
              name === "Knowledge Hub" ||
              name === "Trade Information" ||
              name === "Following") && (
              <hr className="border-t border-[#143A4F] my-3" />
            )}

            {newTab ? (
              <a
                key={name}
                href={link}
                target="_blank"
                onClick={()=>handleSave(name)}
                rel="noopener noreferrer"
                className="flex items-center justify-center md:justify-between text-[13px] my-1 p-2 font-bold text-[#EAA03D] bg-transparent"
              >
                <div className="flex items-center gap-2">
                  <CommonTooltip id={'itemName'} content={collapsed ? name : ''}>
                    <Icon className={`${collapsed ? "h-4 w-4" : "h-6 w-6"}`} />
                  </CommonTooltip>
                  {!collapsed && <span>{name}</span>}
                </div>
                {alert && !collapsed && <RedDotAlert className="h-3 w-3" />}
              </a>
            ) : (
              <NavLink
                key={name}
                to={link}
                onClick={()=>handleSave(name)}
                className={({ isActive }) => {
                  const base = "flex items-center justify-center md:justify-between text-[13px] my-1 p-2";
                  // TIP-494 (Design-2): the Membership tab gets a subtle orange
                  // "nudge" treatment when the user is NOT on it. Active state is
                  // unchanged (solid orange, white text).
                  if (name === "Membership" && !isActive) {
                    return `${base} rounded font-medium text-[#FF8A6B] bg-[rgba(251,81,45,0.14)] shadow-[inset_0_0_0_1px_rgba(251,81,45,0.32)]`;
                  }
                  return `${base} ${(name === "GPTHub" || name === "Knowledge Hubs")
                    ? "text-[#EAA03D] font-bold"
                    : "text-white font-light"
                    } ${(name !== "GPTHub" || name !== "Knowledge Hubs") &&
                    (isActive ? "bg-[#FB512D] rounded" : "bg-transparent")
                    }`;
                }}
                end
              >
                {({ isActive }) => (
                  <>
                    <div className="flex items-center gap-2">
                      <CommonTooltip id={"itemName"} content={collapsed ? name : ''}>
                        <Icon className={`${collapsed ? "h-4 w-4" : "h-6 w-6"}`} />
                      </CommonTooltip>
                      {!collapsed && <span>{name}</span>}
                    </div>
                    {name === "Membership" && !isActive && !collapsed ? (
                      <span className="h-[7px] w-[7px] rounded-full bg-[#FB512D] shrink-0" />
                    ) : (
                      alert && !collapsed && <RedDotAlert className="h-3 w-3" />
                    )}
                  </>
                )}
              </NavLink>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

